import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_upload",
  "use": "svg_upload-usage",
  "viewBox": "0 0 20 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 17\" id=\"svg_upload\"><path d=\"M15.7 13.331c2.188-.573 3.8-2.544 3.8-4.887 0-2.792-2.29-5.055-5.115-5.055h-.052A5.856 5.856 0 0 0 9.27.5C6.472.5 4.134 2.441 3.56 5.035 1.785 5.59.5 7.23.5 9.167.5 11.56 2.463 13.5 4.885 13.5H5.5M10.5 16V8\" stroke=\"currentColor\" stroke-linecap=\"round\" /><path d=\"m7.5 10 2.646-2.646a.5.5 0 0 1 .708 0L13.5 10\" stroke=\"currentColor\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol